import { Card, Descriptions } from "antd";
import PropTypes from "prop-types";

const PersonnelDetails = ({ personnel }) => {
  return (
   <Card>
      <Descriptions column={{sm: 1, lg: 2, xl: 3}}>
        <Descriptions.Item label="Prénoms">
          {personnel?.prenoms ?? 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Nom">
          {personnel?.nom ?? 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Email">
          {personnel?.email ?? 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Téléphone">
          {personnel?.telephone ?? 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Personnel">
          {personnel?.personnel?.name ?? 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Département">
          {personnel?.departement?.nom ?? 'N/A'}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default PersonnelDetails;

PersonnelDetails.propTypes = {
  personnel: PropTypes.object,
};
